import { render, staticRenderFns } from "./game-item.vue?vue&type=template&id=18fc38f4&scoped=true"
import script from "./game-item.vue?vue&type=script&lang=js"
export * from "./game-item.vue?vue&type=script&lang=js"
import style0 from "./game-item.vue?vue&type=style&index=0&id=18fc38f4&prod&lang=scss&scoped=true"
import style1 from "./game-item.vue?vue&type=style&index=1&id=18fc38f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fc38f4",
  null
  
)

export default component.exports